module.exports = __webpack_public_path__ + "img/businessManagement.45b0e83b.svg";